export enum EventPageSlugs {
  Accommodations = 'accommodations',
  Custom = 'custom',
  Faq = 'faq',
  Guests = 'guests',
  Registry = 'registrylinks',
  Rsvp = 'rsvp',
  Schedule = 'schedule',
  Settings = 'settings',
  Story = 'story',
  ThingsToDo = 'things-to-do',
  Travel = 'travel',
  Video = 'video',
  Vip = 'vip',
  WeddingParty = 'weddingparty',
  Welcome = 'welcome',
}
